import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 44, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.85, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const scrollToSection = (id) => {
  const target = document.querySelector(id);
  if (!target) return;
  if (window.__lenis) window.__lenis.scrollTo(target, { offset: -72 });
  else target.scrollIntoView({ behavior: "smooth" });
};
